import { DateTime } from 'luxon'

export const timeScaleOptions = [
    { text: 'letzte 7 Tage', value: { start: DateTime.local().startOf('day').minus({days: 7}).toJSDate(), end: DateTime.local().plus({days: 1}).startOf('day').toJSDate() } },
    { text: 'letzte 30 Tage', value: { start: DateTime.local().startOf('day').minus({days: 30}).toJSDate(), end: DateTime.local().plus({days: 1}).startOf('day').toJSDate() } },
    { text: 'letzte 90 Tage', value: { start: DateTime.local().startOf('day').minus({days: 90}).toJSDate(), end: DateTime.local().plus({days: 1}).startOf('day').toJSDate() } },
]

export const currentCare = (schedule, pointInTimeOrYM) => {
    return currentCareSituation(schedule.careAndProxy?.[0] || [], pointInTimeOrYM)
}
export const currentProxy = (schedule, pointInTimeOrYM) => {
    return currentCareSituation(schedule.careAndProxy?.[1] || [], pointInTimeOrYM)
}
export const currentCareAndProxy = (schedule, pointInTimeOrYM) => {
    return [...new Set([
        ...currentCareSituation(schedule.careAndProxy?.[0] || [], pointInTimeOrYM),
        ...currentCareSituation(schedule.careAndProxy?.[1] || [], pointInTimeOrYM)
    ])]
}
const currentCareSituation = (sections, pointInTimeOrYM) => {
    let effectiveCare = []
    if(typeof pointInTimeOrYM === 'string') {
        let monthDate = DateTime.fromISO(pointInTimeOrYM).toJSDate()
        effectiveCare = sections.length ? [...new Set([
            ...sections.filter(c => c.effective <= monthDate).slice(0).sort((a,b) => b.effective - a.effective).slice(0, 1).reduce((a,c) => a = [...a, ...c.users.map(u => `${u._id}`)], []),
            ...sections.filter(c => c.effective > monthDate && c.effective < DateTime.fromJSDate(monthDate).plus({months: 1}).toJSDate()).reduce((a,c) => a = [...a, ...c.users.map(u => `${u._id}`)], [])
        ])] : []
    } else {
        let sortedSections = sections.slice(0).sort((a,b) => a.effective - b.effective)
        effectiveCare = [...new Set([
            ...(sortedSections[0]?.effective > pointInTimeOrYM ? [sortedSections[0]] : sortedSections.sort((a,b) => b.effective - a.effective).filter(c => c.effective <= pointInTimeOrYM).slice(0, 1)).reduce((a,c) => a = [...a, ...c.users.map(u => `${u._id}`)], [])
        ])]
    }
    return effectiveCare
}